import React from 'react';
import { prop } from 'ramda';

import { AdaChat } from './components/AdaChat';
import { GamesSearch } from './components/GamesSearch';
import { SaferGambling } from './components/SaferGambling';

import { useDeviceSelector } from '@core/js/store/hooks';

import style from './FloatingButtons.scss';

export const FloatingButtons: React.FC = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    if (!isDesktop) {
        return null;
    }

    return (
        <div className={style.container}>
            <SaferGambling />

            <GamesSearch />

            <AdaChat />
        </div>
    );
};
